import React from 'react'
import { url } from 'js/services/Network';
import { formatCurrency } from 'js/services/Format';
import { Link } from '@reach/router';
import CopyItemLink from 'js/new/Components/App/Item/CopyItemLink';

const ItemGrid = ({
  items
}) => {
  return (
    <div className='tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-2'>
      {items.map((item, index) => {
        const link = url('manage-item-page', item)

        return (
          <div key={index} className='tw-bg-white tw-rounded-lg tw-p-3 tw-border-solid tw-border tw-border-gray-100'>
            <div className='tw-h-32'>
              <img src={item.image} alt={item.title} className='tw-w-full tw-h-32 tw-object-cover tw-rounded-xl tw-bg-gray-50' height={'128'} />
            </div>

            <div className='tw-flex tw-justify-between tw-items-center tw-mt-1'>
              <p className='tw-text-gray-600 !tw-mb-0'>{item.title}</p>

              <Link to={link} >
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.9161 13.4501C8.9161 13.6712 8.83736 13.8597 8.67987 14.0157C8.52239 14.1716 8.33308 14.2495 8.11193 14.2495C7.89079 14.2495 7.70226 14.1708 7.54636 14.0133C7.39045 13.8558 7.3125 13.6665 7.3125 13.4453C7.3125 13.2242 7.39124 13.0357 7.54873 12.8798C7.70621 12.7239 7.89552 12.6459 8.11667 12.6459C8.33781 12.6459 8.52634 12.7247 8.68224 12.8821C8.83815 13.0396 8.9161 13.2289 8.9161 13.4501ZM8.9161 8.90655C8.9161 9.12769 8.83736 9.31622 8.67987 9.47212C8.52239 9.62803 8.33308 9.70598 8.11193 9.70598C7.89079 9.70598 7.70226 9.62724 7.54636 9.46975C7.39045 9.31227 7.3125 9.12296 7.3125 8.90181C7.3125 8.68067 7.39124 8.49214 7.54873 8.33624C7.70621 8.18033 7.89552 8.10238 8.11667 8.10238C8.33781 8.10238 8.52634 8.18112 8.68224 8.33861C8.83815 8.49609 8.9161 8.6854 8.9161 8.90655ZM8.9161 4.36302C8.9161 4.58416 8.83736 4.77268 8.67987 4.92859C8.52239 5.08449 8.33308 5.16245 8.11193 5.16245C7.89079 5.16245 7.70226 5.0837 7.54636 4.92622C7.39045 4.76874 7.3125 4.57943 7.3125 4.35828C7.3125 4.13713 7.39124 3.94861 7.54873 3.79271C7.70621 3.6368 7.89552 3.55885 8.11667 3.55885C8.33781 3.55885 8.52634 3.63759 8.68224 3.79508C8.83815 3.95255 8.9161 4.14187 8.9161 4.36302Z" fill="#000000" />
                </svg>
              </Link>
            </div>

            <p className='tw-text-lg tw-font-bold'>{formatCurrency(item.price)} <small className='tw-text-xs tw-font-light'>{item.quantity} available</small></p>

            <CopyItemLink link={link} className={'tw-w-full'} />
          </div>
        )
      })}
    </div>
  )
}

export default ItemGrid
